import { render, staticRenderFns } from "./HeaderSwtOrg.vue?vue&type=template&id=b7e0bdda&scoped=true"
import script from "./HeaderSwtOrg.vue?vue&type=script&lang=js"
export * from "./HeaderSwtOrg.vue?vue&type=script&lang=js"
import style0 from "./HeaderSwtOrg.vue?vue&type=style&index=0&id=b7e0bdda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e0bdda",
  null
  
)

export default component.exports